export default {
  meta: {
    title: '保护期搜索',
  },
};
